import { useTranslation } from 'react-i18next';

const useEnvironmentOptions = () => {
    const { t } = useTranslation(['common']);

    return [
        {
            label: t('common:environment.test'),
            value: 'Test',
        },
        {
            label: t('common:environment.live'),
            value: 'Live',
        },
    ];
};

export default useEnvironmentOptions;
